<template>
	<ui-input
		ref="clipboardInput"
		:label="label"
		:value="value"
		readonly
		@input="$emit('input', $event)"
	>
		<template slot="inlineIcon">
			<ui-button
				:disabled="disabled"
				dense
				icon="fa fa-paste"
				@click="copyInputToClipboard"
			/>
		</template>
	</ui-input>
</template>

<script>
import * as clipboard from "clipboard-polyfill";

import UiButton from "lib/components/ui/Button";
import UiInput from "lib/components/ui/Input";

export default {
	name: "ClipboardInput",
	components: {
		UiButton,
		UiInput
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		},
		hint: {
			type: String,
			default: "Text copied to clipboard",
			required: false
		},
		value: {
			type: String,
			default: "",
			required: false
		}
	},
	methods: {
		copyInputToClipboard() {
			clipboard.writeText(this.value);
			this.$refs.clipboardInput.flashHint(this.hint);
		}
	}
};
</script>
